<template>
  <Modal @close="$emit('close')">
    <h3 slot="header">
      Write your message to {{vendorName}} here,
      and we'll make sure that it gets to the right people.
    </h3>

    <div slot="body" class="ti-form">
      <div class="mb1">
        <div class="form-label">
          <label>Your name / email</label>
        </div>
        <div>
          <input type="text" name="name" disabled class="form-input"
                 :value="`${enquirer.name} <${enquirer.email}>`"/>
        </div>
      </div>
      <div class="mb1">
        <div class="form-label">
          <label>Message</label>
        </div>
        <div>
          <textarea type="textarea" rows="3" name="message" disabled class="form-input"
                    :value="message()"/>
        </div>
      </div>
      <div class="mb1">
        <div class="form-label">
          <label>Additional message (optional)</label>
        </div>
        <div>
          <textarea rows="5" name="message2" class="form-input"
                    v-model="message2" />
        </div>
      </div>

      <div class="mt3">
        <input class="btn btn-primary form-input" type="submit"
               value="Send now" @click="sendEnquire" :disabled="sending">
      </div>
    </div>
  </Modal>
</template>

<script>

import axios from 'axios';
import Modal from '@/components/Modal.vue';

export default {
  name: 'EnquireModal',
  components: { Modal },
  props: {
    vendorId: null,
    vendorName: null,
    enquirer: null,
    tech: null,
    vertical: null,
  },
  data() {
    return {
      sending: false,
      // Enquire form
      message2: '',
    };
  },

  methods: {
    // standard enquire form message
    message() {
      const tech = this.techTitle(this.tech).toUpperCase();
      const sector = this.verticalTitle(this.vertical).toUpperCase();
      return `I'm interested to know more about your ${tech} capabilities in ${sector}.`;
    },

    sendEnquire() {
      this.sending = true;
      const postData = {
        tech: this.tech,
        sector: this.vertical,
        message: this.message2,
      };
      axios.post(`/api/connect/${this.vendorId}/enquire`, postData, { })
        .then(() => {
          alert('Enquire sent');
          this.$emit('close');
        });
    },
  },
};
</script>
